(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halo-instagram"] && !Shopify.designMode) return;
  try {
    
  // Swap the cover for the video in place on click. Because the video element
  // carries preload="none", no video bytes are fetched until this runs.
  // Only one reel plays at a time.
  (() => {
    const onClick = (event) => {
      const trigger = event.target.closest('.halo-ig__trigger');
      if (!trigger) return;

      const media = trigger.closest('.halo-ig__media');
      const player = media && media.querySelector('.halo-ig__player');
      const video = player && player.querySelector('video');
      if (!video) return;

      // stop any reel already playing in this rail
      const rail = trigger.closest('.halo-ig__rail');
      if (rail) {
        rail.querySelectorAll('video').forEach((other) => {
          if (other !== video) {
            other.pause();
            const otherPlayer = other.closest('.halo-ig__player');
            const otherMedia = other.closest('.halo-ig__media');
            if (otherPlayer) otherPlayer.hidden = true;
            if (otherMedia) {
              const otherTrigger = otherMedia.querySelector('.halo-ig__trigger');
              if (otherTrigger) otherTrigger.hidden = false;
            }
          }
        });
      }

      trigger.hidden = true;
      player.hidden = false;
      video.play().catch(() => {
        // autoplay refused, leave the controls for the visitor
      });
    };

    document.addEventListener('click', onClick);

    // return a card to its cover once the reel finishes
    document.addEventListener(
      'ended',
      (event) => {
        const video = event.target;
        if (!video.matches || !video.matches('.halo-ig__player video')) return;
        const media = video.closest('.halo-ig__media');
        const player = video.closest('.halo-ig__player');
        if (player) player.hidden = true;
        if (media) {
          const trigger = media.querySelector('.halo-ig__trigger');
          if (trigger) trigger.hidden = false;
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-reviews"] && !Shopify.designMode) return;
  try {
    
  // Drifts the review list down on its own so the section reads as alive, while
  // staying a real overflow container so anyone can grab it and scroll normally.
  // A CSS transform marquee cannot do both: it moves the content out from under
  // the scrollbar, so manual scrolling stops working.
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const start = (el) => {
      if (el.dataset.autoscroll !== 'true') return;
      const speed = parseFloat(el.dataset.speed || '25');
      let paused = false;
      let last = null;
      let frame = null;

      const pause = () => { paused = true; };
      const resume = () => { paused = false; };

      // any sign the reader is engaging hands control straight back to them
      el.addEventListener('pointerenter', pause);
      el.addEventListener('pointerleave', resume);
      el.addEventListener('focusin', pause);
      el.addEventListener('focusout', resume);
      el.addEventListener('touchstart', pause, { passive: true });
      el.addEventListener('wheel', pause, { passive: true });

      const step = (now) => {
        if (last === null) last = now;
        const dt = (now - last) / 1000;
        last = now;
        const limit = el.scrollWidth - el.clientWidth;
        if (!paused && limit > 1) {
          let next = el.scrollLeft + speed * dt;
          if (next >= limit) next = 0;   // wrap back to the top
          el.scrollLeft = next;
        }
        frame = requestAnimationFrame(step);
      };

      // only run while the section is actually on screen
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && frame === null) {
            last = null;
            frame = requestAnimationFrame(step);
          } else if (!entry.isIntersecting && frame !== null) {
            cancelAnimationFrame(frame);
            frame = null;
          }
        });
      }, { threshold: 0.15 });
      io.observe(el);
    };

    // Scroll-linked drift, layered on top of the ambient one above. As the
    // section crosses the viewport the row is nudged along in proportion to
    // how far through it the reader has travelled, so the testimonials feel
    // connected to the page rather than running on their own clock.
    //
    // Opt-in per section, because this section is also on the product page
    // where the ambient drift alone is the intended behaviour.
    //
    // The offset is additive and is applied as a delta rather than an
    // absolute scrollLeft, so it composes with the ambient drift instead of
    // fighting it for ownership of the scroll position.
    const startScrollLink = (el) => {
      if (el.dataset.scrollLinked !== 'true') return;

      const strength = parseFloat(el.dataset.scrollLinkedStrength || '50') / 100;
      if (!(strength > 0)) return;

      let lastProgress = null;
      let ticking = false;
      let engaged = false;

      // Once the reader touches the row, the page stops steering it.
      const disengage = () => { engaged = false; };
      el.addEventListener('pointerdown', disengage);
      el.addEventListener('touchstart', disengage, { passive: true });

      const apply = () => {
        ticking = false;
        const rect = el.getBoundingClientRect();
        const span = window.innerHeight + rect.height;
        if (span <= 0) return;

        // 0 as the row enters from the bottom, 1 as it leaves past the top.
        const progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / span));
        if (lastProgress === null) { lastProgress = progress; engaged = true; return; }

        const limit = el.scrollWidth - el.clientWidth;
        if (engaged && limit > 1) {
          const delta = (progress - lastProgress) * limit * strength;
          let next = el.scrollLeft + delta;
          if (next > limit) next = limit;
          if (next < 0) next = 0;
          el.scrollLeft = next;
        }
        lastProgress = progress;
      };

      const onScroll = () => {
        engaged = true;
        if (!ticking) { ticking = true; requestAnimationFrame(apply); }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => { lastProgress = null; }, { passive: true });
      apply();
    };

    const init = () => {
      if (reduce.matches) return;
      document.querySelectorAll('.halo-rv__scroll').forEach((el) => {
        start(el);
        startScrollLink(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
